module.exports = __webpack_public_path__ + "static/media/load.750fc7f7.gif";